import React, { useCallback, useEffect, useRef } from 'react';
import { injectIntl } from 'react-intl-next';
import { ProductSearchInput } from '../../../common/product-search-input';
import { messages } from '../../../messages';
import { useProductContext } from '../../product-router';
import { useFeaturesContext } from '../../features-context';
import { useQueryParams } from '../../query-params-context';
var debounceTime = 250;
var GenericInputWithIntl = function GenericInputWithIntl(_ref) {
  var _queryParams$text;
  var activeProductId = _ref.activeProductId,
    intl = _ref.intl,
    onNavigateGeneric = _ref.onNavigateGeneric,
    query = _ref.query,
    isExpanded = _ref.isExpanded,
    isLoading = _ref.isLoading,
    onOpen = _ref.onOpen,
    forwardRef = _ref.forwardRef,
    onBack = _ref.onBack,
    setQuery = _ref.setQuery,
    shouldFillContainer = _ref.shouldFillContainer;
  var _useProductContext = useProductContext(),
    getProduct = _useProductContext.getProduct;
  var _useFeaturesContext = useFeaturesContext(),
    isGriffinNavEnabled = _useFeaturesContext.isGriffinNavEnabled;
  var _useQueryParams = useQueryParams(),
    queryParams = _useQueryParams.queryParams;
  var hasQueryParamText = queryParams === null || queryParams === void 0 ? void 0 : queryParams.hasOwnProperty('text');
  var queryParamText = (queryParams === null || queryParams === void 0 || (_queryParams$text = queryParams.text) === null || _queryParams$text === void 0 ? void 0 : _queryParams$text.toString()) || '';
  var onNavigateGenericInput = useCallback(function (productId) {
    return function (href, event) {
      if (href) {
        onNavigateGeneric(productId, href, event);
      }
    };
  }, [onNavigateGeneric]);

  // We're using a ref for setQuery so that we can guarantee the function
  // definition is the same reference between renders.
  var setQueryRef = useRef(setQuery);
  useEffect(function () {
    setQueryRef.current = setQuery;
  }, [setQuery]);
  useEffect(function () {
    if (isGriffinNavEnabled && hasQueryParamText) {
      setQueryRef.current(queryParamText);
    }
  }, [isGriffinNavEnabled, hasQueryParamText, queryParamText, setQueryRef]);
  var _ref2 = function (_getProduct, _getProduct$generateA, _getProduct2, _getProduct2$generate, _getProduct3) {
      if (!activeProductId || !getProduct(activeProductId)) {
        return {
          advancedSearchUrl: '',
          secondaryAdvancedSearchURL: '',
          onNavigate: isGriffinNavEnabled ? onNavigateGenericInput('') : function () {},
          actionSubjectId: 'noActiveProduct'
        };
      }
      return {
        advancedSearchUrl: ((_getProduct = getProduct(activeProductId)) === null || _getProduct === void 0 || (_getProduct$generateA = _getProduct.generateAdvancedSearchUrl) === null || _getProduct$generateA === void 0 ? void 0 : _getProduct$generateA.call(_getProduct, query)) || '',
        secondaryAdvancedSearchURL: ((_getProduct2 = getProduct(activeProductId)) === null || _getProduct2 === void 0 || (_getProduct2$generate = _getProduct2.generateAdvancedSearchUrl) === null || _getProduct2$generate === void 0 ? void 0 : _getProduct2$generate.call(_getProduct2, query, undefined, 'onInputEnterModified')) || '',
        expandedStateInputPlaceholder: ((_getProduct3 = getProduct(activeProductId)) === null || _getProduct3 === void 0 ? void 0 : _getProduct3.expandedStateInputPlaceholder) || '',
        onNavigate: onNavigateGenericInput(activeProductId),
        actionSubjectId: activeProductId
      };
    }(),
    advancedSearchUrl = _ref2.advancedSearchUrl,
    secondaryAdvancedSearchURL = _ref2.secondaryAdvancedSearchURL,
    onNavigate = _ref2.onNavigate,
    actionSubjectId = _ref2.actionSubjectId,
    expandedStateInputPlaceholder = _ref2.expandedStateInputPlaceholder;
  return /*#__PURE__*/React.createElement(ProductSearchInput, {
    shouldFillContainer: shouldFillContainer,
    forwardRef: forwardRef,
    value: query,
    isExpanded: isExpanded,
    isLoading: isLoading,
    onOpen: onOpen,
    debounceTime: debounceTime,
    advancedSearchURL: advancedSearchUrl,
    secondaryAdvancedSearchURL: secondaryAdvancedSearchURL,
    actionSubjectId: actionSubjectId,
    onBack: onBack,
    onInput: setQuery,
    expandedPlaceholder: expandedStateInputPlaceholder ? expandedStateInputPlaceholder : intl.formatMessage(messages.common_search_input_collapsed_placeholder),
    collapsedPlaceholder: intl.formatMessage(messages.common_search_input_collapsed_placeholder),
    onNavigate: onNavigate
  });
};
export var GenericProductSearchInput = injectIntl(GenericInputWithIntl);